import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import css from '../style.module.scss';
import setQaAttribute from '../../../helpers/setQaAttribute';
import {
  SUPPORT_SEARCH_RESULT_ITEM,
  SUPPORT_SEARCH_RESULT_ITEM_DESCRIPTION,
  SUPPORT_SEARCH_RESULT_ITEM_TITLE,
} from '../../../constants/qaAttributes';

interface IProps {
  title?: string;
  description: string;
  type: string;
  link: string;
  isMobile?: boolean;
  isFirst?: boolean;
}

const SearchResult: FC<IProps> = ({
  type,
  title,
  description,
  link,
  isMobile,
  isFirst,
}: IProps) => (
  <Link
    to={link}
    className={classNames(css.result, {
      [css.isMobile]: isMobile,
      [css.isFirst]: isFirst,
    })}
    {...setQaAttribute(SUPPORT_SEARCH_RESULT_ITEM)}
  >
    <div className={css.result__icon}>
      <Icon id={`24--search-${type}`} />
    </div>
    <div className={css.result__info}>
      <div className={css.result__title} {...setQaAttribute(SUPPORT_SEARCH_RESULT_ITEM_TITLE)}>
        {title}
      </div>
      <div
        onClick={(e) => {
          if ((e.target as HTMLElement).tagName === 'A') {
            e.stopPropagation();
          }
        }}
        className={css.result__description}
        {...setQaAttribute(SUPPORT_SEARCH_RESULT_ITEM_DESCRIPTION)}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  </Link>
);

export default SearchResult;
